import { EmploymentType } from '@thesavingsgroup/enums/EmploymentType';
import i18n from 'i18next';

import { EmployedTypeOption } from '../types/EmployedTypeOption';

export const employedTypeOptions: EmployedTypeOption[] = [
  {
    name: i18n.t('employmentType.fullTime'),
    value: EmploymentType.FULL_TIME,
  },
  {
    name: i18n.t('employmentType.partTime'),
    value: EmploymentType.PART_TIME,
  },
  {
    name: i18n.t('employmentType.selfEmployed'),
    value: EmploymentType.SELF_EMPLOYED,
  },
  {
    name: i18n.t('employmentType.military'),
    value: EmploymentType.ACTIVE_MILITARY,
  },
];
